<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/icofont/1.0.1/icofont.min.css">
</head>

<body>
  <app-navbar [business]="business" [menuUrl]="menuUrl"></app-navbar>

  <section *ngIf="business && business.sliders && business.sliders.length > 0" class="pt-0 pb-0" id="home">
    <div class="slider-bg">
      <ul class="slides">
        <li>
          <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
            <ng-template carouselSlide *ngFor="let slide of business.sliders">
              <div class="slide-img" [style.backgroundImage]="getSliderImageUrl(slide)">
                <div class="hero-text-wrap">
                  <div class="hero-text white-color">
                    <div class="container text-center">
                      <h1 class="title raleway-font">{{slide.description || 'Welcome to'}}</h1>
                      <h2 class="white-color font-700">{{business.name}}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </li>
      </ul>
    </div>
  </section>

  <section *ngIf="business && business.services && business.services.length > 0" class="white-bg pb-80" id="services">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">What We Offer</h1>
            <h2 class="raleway-font">At {{business.name}}, we serve more than just great products.</h2>
          </div>
        </div>
      </div>
      <div class="row mt-50" [ngClass]="{'justify-content-center': business.services.length < 3}">
        <div *ngFor="let service of business.services" [ngClass]="getServiceColumnClass(business.services.length)"
          class="mb-30 feature-box text-center hover-effect">
          <div class="default-bg-icon mb-20">
            <ng-container *ngIf="service.icon_url; else defaultIcon">
              <img [src]="getServiceIconUrl(service.icon_url)" alt="{{service.name}} Icon" class="service-icon">
            </ng-container>
            <ng-template #defaultIcon>
              <i class="fas fa-cogs font-30px white-color"></i>
            </ng-template>
          </div>
          <h5 class="mt-10">{{service.name}}</h5>
          <p class="font-400">{{service.description}}</p>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="business && (business.about_us || business.postal_address || business.social_urls?.work_hours)"
    class="gray-bg" id="about">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">We Are {{business.name}}</h1>
            <h2 class="raleway-font">About Us</h2>
          </div>
          <p *ngIf="business.about_us">{{business.about_us}}</p>
        </div>
      </div>
      <div class="row mt-50 justify-content-center">
        <div class="col-md-5 col-xs-12 text-center">
          <div *ngIf="business.postal_address" class="about-info-item mb-20">
            <h4><i class="fas fa-map-marker-alt mr-10"></i> {{business.postal_address}}</h4>
          </div>
          <div *ngIf="business.social_urls?.work_hours" class="about-info-item">
            <h4><i class="fas fa-clock mr-10"></i> {{business.social_urls?.work_hours}}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    *ngIf="business && (business.postal_address || business.office_numbers?.length || business.email || business.social_urls?.support_email || getSocialMediaLinks().length || business.social_urls?.deliveries?.length)"
    class="white-bg transition-none" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">Just Keep In Touch</h1>
            <h2 class="raleway-font">Contact Us Now</h2>
          </div>
        </div>
      </div>
      <div class="row mt-70">
        <div *ngIf="business.postal_address || business.office_numbers?.length || business.social_urls?.support_email"
          class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
          <div class="row mt-20">
            <div *ngIf="business.postal_address" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color"><i class="fas fa-map-marker-alt mr-10"></i> Postal Address</h2>
                <p class="mt-30">{{business.postal_address}}</p>
              </div>
            </div>
            <div *ngIf="business.office_numbers?.length" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color"><i class="fas fa-phone-alt mr-10"></i> Office Number</h2>
                <p *ngFor="let number of business.office_numbers" class="mb-0 mt-30">{{number}}</p>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div *ngIf="business.social_urls?.support_email" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color"><i class="fas fa-headset mr-10"></i> Support</h2>
                <p class="mb-0 mt-30">{{business.social_urls?.support_email}}</p>
              </div>
            </div>
            <div *ngIf="business.social_urls?.deliveries" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color"><i class="fas fa-truck mr-10"></i> Delivery Services</h2>
                <p *ngFor="let delivery of business.social_urls?.deliveries" class="mb-0 mt-30">
                  <a [href]="delivery" target="_blank" rel="noopener noreferrer">{{delivery}}</a></p>
              </div>
            </div>

          </div>
          <div class="row mt-20">
            <div class="col-md-12 social-icons-style-01 text-center">
              <ul class="md-icon left-icon">
                <li *ngFor="let social of getSocialMediaLinks()">
                  <a [href]="social.link" target="_blank" rel="noopener noreferrer" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
          <div *ngIf="business.social_urls?.deliveries?.length" class="row mt-20">
            <div class="col-md-12 text-center">

            </div>
          </div>
        </div>
        <div [ngClass]="{
          'col-md-6 col-sm-6 col-xs-12': (business.postal_address || business.office_numbers?.length || business.social_urls?.support_email),
          'col-md-8 col-sm-8 col-xs-12 offset-md-2': !(business.postal_address || business.office_numbers?.length || business.social_urls?.support_email)
        }">
          <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="visually-hidden" for="user_name">Name</label>
                  <input type="text" minlength="2" maxlength="15"
                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name" class="md-input"
                    id="user_name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                  <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                    Name is required.
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="mb-3">
                  <label class="visually-hidden" for="user_email">Email</label>
                  <input type="email" minlength="2" maxlength="35"
                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input"
                    id="user_email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel"
                    required email>
                  <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                    A valid email is required.
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12">
                <div class="mb-3">
                  <label class="visually-hidden" for="message">Message</label>
                  <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                    class="md-textarea" id="message" rows="7" placeholder="Message" [(ngModel)]="formData.message"
                    #userMessage="ngModel" required></textarea>
                  <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                    Message is required.
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12">
                <div class="text-left mt-20">
                  <button type="submit" name="submit"
                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin" [disabled]="contactForm.invalid"
                    value="Send">
                    <span>Send Message <i class="ion-android-arrow-forward"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <app-footer [business]="business"></app-footer>
  <ngx-scrolltop></ngx-scrolltop>
</body>

</html>